import { Container } from '@chakra-ui/react';
import HtmlToReact from 'html-to-react';
import { privacyPolicy } from '../../../../mock/privacyPolicy';

const HtmlToReactParser = HtmlToReact.Parser;
export default function PrivacyPolicyPage() {
    const htmlToReactParser = new HtmlToReactParser();
    const reactElement = htmlToReactParser.parse(privacyPolicy);

    return (
        <Container maxW='7xl' p={5}>
            {reactElement}
        </Container>
    );
}
